import React, { Dispatch, SetStateAction } from 'react'
import { Icon, Modal } from 'components'
import { useSelector } from 'store/store'

import * as S from './styles'
import { OverviewValue } from './components'
import { theme } from 'styles/theme/hav-theme'

interface OrderOverviewModalProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  loadingConfirm?: boolean
  onReturn?: () => void
  disabled?: boolean
}

const OrderOverviewModal: React.FC<OrderOverviewModalProps> = ({
  open,
  setOpen,
  onConfirm,
  loadingConfirm,
  onReturn = () => setOpen(false),
  disabled = false
}) => {
  const { simulateOrder } = useSelector((state) => state.salesOrder)
  const qt_ov_gera = simulateOrder?.resumo.vl_tota_orde_gera

  return (
    <Modal
      open={open}
      title="Resumo"
      titleSize={22}
      descriptionSize={14}
      modalWidth={456}
      description={
        <>
          Confira abaixo a simulação da distribuição dos materiais do pedido{' '}
          <strong>#{simulateOrder?.nr_pedi_rasc}</strong>
        </>
      }
      setOpen={setOpen}
      showReturn
      returnIcon={''}
      returnText="Voltar"
      returnAction={onReturn}
      buttonText="Confirmar"
      buttonAction={onConfirm}
      loading={loadingConfirm}
      buttonDisabled={disabled}
    >
      <S.OverviewValues>
        <OverviewValue
          icon={<Icon icon="edit" color={theme.colors.neutral[60]} size="16" />}
          title="Em aberto"
          subtitle={`${simulateOrder?.resumo.qt_item_aber_resu_conv} pares`}
          tooltip="Materiais que não geraram OVs durante a transação."
          value={simulateOrder?.resumo.vl_item_aber_resu ?? 0}
          iconColorBackground={theme.colors.neutral.wrapicon}
        />
        <OverviewValue
          icon={<Icon icon="report" color={theme.colors.alert.warning.dark} size="16" />}
          title="Em análise"
          subtitle={`${simulateOrder?.resumo.qt_item_anls_resu_conv} pares`}
          tooltip="Materiais sem disponibilidade de cota e/ou estoque, mas com solicitação de volume extra."
          value={simulateOrder?.resumo.vl_item_anls_resu ?? 0}
          iconColorBackground={theme.colors.alert.warning[10]}
        />
        <OverviewValue
          icon={
            <Icon icon="task-alt" color={theme.colors.alert.success.dark} size="16" />
          }
          title="OVs geradas"
          subtitle={`${simulateOrder?.resumo.qt_item_conv_orde} pares -> ${qt_ov_gera} ${
            qt_ov_gera && qt_ov_gera > 1 ? 'ovs' : 'ov'
          }`}
          tooltip="Materiais que atendem aos requisitos de cota, estoque e/ou valor mínimo, que estão aptos para gerar OVs e serem enviados ao SAP. Os valores apresentados são simulações; confirme a solicitação para garantir a sua disponibilidade."
          value={simulateOrder?.resumo.vl_item_orde ?? 0}
          iconColorBackground={theme.colors.alert.success[10]}
        />
      </S.OverviewValues>

      <S.ObservationText>
        Ao clicar em confirmar, as OVs geradas serão{' '}
        <strong>enviadas automaticamente ao SAP.</strong>
        Materiais em aberto ou em análise{' '}
        <strong>não possuem garantia de disponibilidade.</strong>
      </S.ObservationText>
    </Modal>
  )
}

export default OrderOverviewModal
